/**
 * Use Case: Atualizar Estágio do Funil
 * Orquestra a atualização de um estágio existente
 */

import { IFunnelStageRepository } from '../../../domain/repositories/IFunnelStageRepository';
import { NotFoundError } from '../../../core/errors/DomainErrors';

export interface UpdateFunnelStageDTO {
    id: string;
    name?: string;
    conversionEvent?: string;
    order?: number;
    deadline?: number;
    color?: string | null;
}

export class UpdateFunnelStageUseCase {
    constructor(private readonly funnelStageRepository: IFunnelStageRepository) { }

    async execute(dto: UpdateFunnelStageDTO): Promise<void> {
        // Busca estágio existente
        const stage = await this.funnelStageRepository.findById(dto.id);

        if (!stage) {
            throw new NotFoundError('Estágio do funil', dto.id);
        }

        // Atualiza campos usando métodos da entidade
        if (dto.name !== undefined) {
            stage.updateName(dto.name);
        }

        if (dto.conversionEvent !== undefined) {
            stage.updateConversionEvent(dto.conversionEvent);
        }

        if (dto.order !== undefined) {
            stage.updateOrder(dto.order);
        }

        if (dto.deadline !== undefined) {
            stage.updateDeadline(dto.deadline);
        }

        if (dto.color !== undefined) {
            stage.color = dto.color;
        }

        // Persiste
        await this.funnelStageRepository.save(stage);
    }
}
